// export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
// export const BASE_API_URL = "https://dev-mropro-api.digiryte.co.uk"
// export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
// export const BASE_API_URL = "https://dev-mropro-api.digiryte.co.uk"
export const BASE_API_URL_BOXP = process.env.REACT_APP_BASE_API_URL_BOXP
export const BASE_API_URL_BOXR = process.env.REACT_APP_BASE_API_URL_BOXR
// export const BASE_API_URL = "preprod-mropro-api.digiryte.co.uk"
// export const BASE_API_URL = "http://localhost:3000" ;
//Change redirect url in reset password flow when changing domain name
